import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const propertyTreeApi = createApi({
    reducerPath: "propertyTreeApi",
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getProperties: builder.query<
            { properties: string[] } | { values: string[] },
            { url: string; limit?: number | null }
        >({
            query: ({ url }) => ({ url }),
            transformResponse: (data: { properties: string[] } | { values: string[] }, _meta, { limit = 400 }) =>
                "values" in data && limit !== null ? { values: data.values.slice(0, limit) } : data,
        }),
    }),
});

export const { useGetPropertiesQuery, useLazyGetPropertiesQuery } = propertyTreeApi;
